<header
    class="w-full relative aspect-square md:aspect-auto bg-no-repeat bg-cover"
    [ngClass]="{
            'md:min-h-[425px]': component.minHeight === 'small' || !component.minHeight,
            'md:min-h-screen': component.minHeight === 'large',
            'md:min-h-[50vh]': component.minHeight === 'medium',
        }">
    <advanced-image
        *ngIf="img && !component.video"
        class="w-full object-cover overflow-hidden z-0 md:aspect-auto aspect-square"
        [alt]="component.caption || 'Powered by Voyse'"
        [cldImg]="img"
        [width]="imageWidth"
        [height]="imageHeight"
        [plugins]="plugins"></advanced-image>
    <app-header-video  *ngIf="component.video" [component]="component"></app-header-video>
    <span role="img" [attr.aria-label]="component.altText"></span>
    <div class="absolute top-0 left-0 w-full h-full background-black/40" [style]="backgroundStyle">
        <div
            class="w-full h-full items-start text-left container mx-auto flex flex-col gap-2 md:p-8 p-4 md:gap-4 justify-center"
            [ngClass]="{
                'md:items-center md:text-center': component.alignText === 'center',
                'md:items-end md:text-right': component.alignText === 'right',
                'md:items-start md:text-left': component.alignText === 'left',
            }">
            <ng-container *ngIf="job && component.jobTextOverride" [ngTemplateOutlet]="customOverlayJobContent"></ng-container>
            <ng-container *ngIf="job && !component.jobTextOverride" [ngTemplateOutlet]="overlayJobContent"></ng-container>
            <ng-container *ngIf="page" [ngTemplateOutlet]="overlayPageContent"></ng-container>
        </div>
    </div>
</header>

<ng-template #customOverlayJobContent>
    <div
        [ngStyle]="textStyle"
        class="text-3xl"
        [innerHTML]="sanitizedContent"
        [ngClass]="{
            'text-6xl md:text-4xl': component.textSize === 'xlarge',
            'text-4xl md:text-6xl': component.textSize === 'large',
            'text-3xl md:text-5xl': component.textSize === 'regular',
            'text-2xl md:text-4xl': component.textSize === 'small',
        }">
    </div>
    <div class="flex flex-col gap-2 mt-2 md:mt-4" [ngClass]="component.alignText">
        <app-apply-button
            *ngIf="component.showApplyButton !== false"
            [job]="job"
            [component]="component"
            [buttonConfig]="component.buttonConfig"></app-apply-button>
        <app-job-details-button
            *ngIf="component.showMoreDetailsButton !== false"
            [job]="job"
            [component]="component"
            [buttonConfig]="component.moreDetailsButtonConfig"></app-job-details-button>
    </div>
</ng-template>

<ng-template #overlayJobContent>
    <h1
        *ngIf="component.showJobTitle !== false"
        [ngStyle]="textStyle"
        class="text-3xl"
        [ngClass]="{
            'text-6xl md:text-4xl': component.textSize === 'xlarge',
            'text-4xl md:text-6xl': component.textSize === 'large',
            'text-3xl md:text-5xl': component.textSize === 'regular',
            'text-2xl md:text-4xl': component.textSize === 'small',
        }">
        {{ job?.title }}
    </h1>
    <p
        *ngIf="component.showJobLocation !== false"
        [ngClass]="{
        'text-3xl md:text-5xl': component.textSize === 'xlarge',
        'text-xl md:text-2xl': component.textSize === 'large',
        'text-lg md:text-xl': component.textSize === 'regular',
        'text-base md:text-lg': component.textSize === 'small',
    }"
        [ngStyle]="textStyle">
        {{ job?.locationLabel || job?.location }}
    </p>
    <div class="flex flex-col gap-2 mt-2 md:mt-4" [ngClass]="component.alignText">
        <app-apply-button
            *ngIf="component.showApplyButton !== false"
            [job]="job"
            [component]="component"
            [buttonConfig]="component.buttonConfig"></app-apply-button>
        <app-job-details-button
            *ngIf="component.showMoreDetailsButton !== false"
            [job]="job"
            [component]="component"
            [buttonConfig]="component.moreDetailsButtonConfig"></app-job-details-button>
    </div>
</ng-template>

<ng-template #overlayPageContent>
    <h1
        [ngStyle]="textStyle"
        class="text-3xl"
        [ngClass]="{
        'text-6xl md:text-4xl': component.textSize === 'xlarge',
        'text-4xl md:text-6xl': component.textSize === 'large',
        'text-3xl md:text-5xl': component.textSize === 'regular',
        'text-2xl md:text-4xl': component.textSize === 'small',
    }">
        {{ component.text }}
    </h1>
    <p
        *ngIf="component.strapline"
        [ngClass]="{
            'text-3xl md:text-5xl': component.textSize === 'xlarge',
            'text-2xl md:text-4xl': component.textSize === 'large',
            'text-lg md:text-2xl': component.textSize === 'regular',
            'text-base md:text-lg': component.textSize === 'small',
        }"
        [ngStyle]="textStyle">
        {{ component.strapline }}
    </p>
    <div *ngIf="component.cta">
        <app-cta [component]="component" [page]="page"></app-cta>
    </div>
</ng-template>

<app-typeface-loader [fontFamily]="typeface"></app-typeface-loader>
